/**
 * Component used to display a consistent page title.
 * As of 2023-08-29, added back button option.
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';
import BackButton from './BackButton';

const styleSheet = theme => ({
    container: {
      marginBottom: 24
    },
    containerNoMargin: {
    },
    suffixLabel: {
      color: theme.palette.secondary.main,
    },  
});

class PageTitle extends Component {
    
  render() {
    const classes = this.props.classes;

    let theContainerClass = classes.container;
    if (this.props.noMargin === true) {
      theContainerClass = classes.containerNoMargin;
    }

    if (this.props.showBackButton === true) {
      return (
        <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="flex-start" className={theContainerClass}>
          <Grid item>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item>
                    <Typography variant="h4">{this.props.title}</Typography>
                  </Grid>
                  { this.props.titleSuffix != null &&
                  <Grid item>
                    <Typography className={classes.suffixLabel} variant="h4">{this.props.titleSuffix}</Typography>
                  </Grid>}
                </Grid>
              </Grid>
              { this.props.subtitle != null &&
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  {this.props.subtitle}
                </Typography>
              </Grid>}
            </Grid>
          </Grid>
          <Grid item>
            <BackButton name={this.props.name} backLink={this.props.backLink} {...this.props}/>
          </Grid>
        </Grid>
      );
    }

    return (
      <Grid container spacing={0} alignItems="center" className={theContainerClass}>
        <Grid item xs={12}>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <Typography variant="h4">{this.props.title}</Typography>
            </Grid>
            { this.props.titleSuffix != null &&
            <Grid item>
              <Typography className={classes.suffixLabel} variant="h4">{this.props.titleSuffix}</Typography>
            </Grid>}
          </Grid>
        </Grid>
        { this.props.subtitle != null &&
        <Grid item xs={12}>
          <Typography variant="subtitle1">
            {this.props.subtitle}
          </Typography>
        </Grid>}
      </Grid>
    );
  }
}
  
export default withStyles(styleSheet)(PageTitle);